import {
    AUTH_2FA,
    AUTH_LOGIN,
    AUTH_LOGOUT,
    AUTH_TEST,
    RESET_PASSWORD_STEP1,
    RESET_PASSWORD_STEP2,
    RESET_PASSWORD_STEP3
} from './endpoints'

/**
 * /auth/login/
 *
 * Begin authentication process
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {
 *    email: 'foo@bar.tld',
 *    password: 'foobar'
 * }
 */
export const login = (request, payload) => {
    const isTestMode = false;

    if (!isTestMode) {
        //try {
            return request.post(AUTH_LOGIN, payload);
        //} catch (e) {}
    } else {
        try {
            return new Promise((resolve, reject) => {
                return resolve({
                    data: {
                        token: '123456',
                        first_name: 'John',
                        last_name: 'Doe',
                        email: 'john.doe@email.tld',
                        mobileNumber: '0123 456789',
                        customerAccounts: [
                            {
                                id: '8ghd7',
                                customerType: payload.customer_type,
                                room: { contract: payload.room_contract },
                                hasAgreedToTheStorageLicence: false,
                                checkInComplete: 0,
                            },
                        ],
                    },
                });
            });
        } catch (e) {
            console.error(e);
        }
    }
};

/**
 * /auth/token/
 *
 * Complete authentication process
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {
 *    code: '123456'
 * }
 */
export const token = (request, payload) => {
    payload.code = payload.code.trim();
    try {
        return request.post(AUTH_2FA, payload);
    } catch (e) {
        console.debug(e);
    }
};

export const sign_out = (request) => {
    try {
        return request.post(AUTH_LOGOUT, {});
    } catch (e) {
        console.debug(e);
    }
}

export const auth_test = (request) => {
    try {
        return request.get(AUTH_TEST, {});
    } catch (e) {
        console.debug(e);
    }
}

/**
 * Reset password step 1
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {
 *    email: 'foo@bar.tld',
 * }
 */
export const reset_password_step1 = (request, payload) => {
    try {
        return request.post(RESET_PASSWORD_STEP1, payload);
    } catch (e) {
        console.debug(e);
    }
};

/**
 * Reset password step 2
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {
 *    token: '2RZSEHPW6RLA',
 * }
 */
export const reset_password_step2 = (request, payload) => {
    try {
        return request.post(RESET_PASSWORD_STEP2, payload);
    } catch (e) {
        console.debug(e);
    }
};

/**
 * Reset password step 3
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {
 *    token: '2RZSEHPW6RLA',
 *    code: 'V3N2C',
 *    password: 'password_strong'
 * }
 */
export const reset_password_step3 = (request, payload) => {
    try {
        return request.post(RESET_PASSWORD_STEP3, payload);
    } catch (e) {
        console.debug(e);
    }
};

export const test_token = (request, payload) => {
    try {
        return request.get(RESET_PASSWORD_STEP3, payload);
    } catch (e) {
        console.debug(e);
    }
};
